/* eslint-disable prettier/prettier */
import { Typography } from '@mui/material';
import NavGroup from './NavGroup';
import { itemlist } from 'menu-items/itemlist';
import { useState, useEffect } from 'react';
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';
import { useSelector } from 'react-redux';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const customization = useSelector((state) => state.customization); // Use hook inside component
    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        const fetchItems = () => {
            try {
                const response = itemlist(customization);
                setMenuItems(response?.items || []); // Ensure menuItems is always an array
            } catch (error) {
                console.error('Error fetching menu items:', error);
            }
        };
        fetchItems();
    }, [customization]);

    const navItems = menuItems?.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            case 'collapse':
                return <NavCollapse key={item?.id} menu={item} level={1} />;
            case 'item':
                return <NavItem key={item?.id} item={item} level={1} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        MenuList Menu Items Error
                    </Typography>
                );
        }
    });

    return <div style={{ marginTop: '10px',display:'flex', flexDirection:'column',alignItems:'center', justifyContent:'center' }}>{navItems}</div>;
};

export default MenuList;
